( function() {
    const iconSpritePath = 'assets/icons/build/';

    const loadSVG = ( url ) => {
        var xhr = new XMLHttpRequest();
        xhr.open( "GET", url, true );
        xhr.send();
        xhr.onload = function( e ) {
            // If not success result, ignore
            if ( xhr.status !== 200 ) {
                console.log( 'Sprite failed to load.', xhr.statusText );
                return;
            }
            
            var div = document.createElement( 'div' );
            div.id = 'beliefsvgloader-sprite';
            div.style.cssText = 'border: 0; clip: rect(0 0 0 0); height: 0; overflow: hidden; padding: 0; position: absolute; width: 0; opacity: 0;';
            div.innerHTML = xhr.responseText;
            document.body.insertBefore( div, document.body.childNodes[0] );
        };
    }

    loadSVG( `/wp-content/themes/badigital_wp/${iconSpritePath}icons.svg` );
} )();